import { combineReducers } from 'redux'
import session from './session'
import isGlobalsFetching from './isGlobalsFetching'
import comboboxes from './comboboxes'
import counts from './counts'
import search from './search'
import patient from './patient'
import consultation from './consultation'
import patients from './patients'
import isPatientsLoading from './isPatientsLoading'



const rootReducer = combineReducers({
	session,
	isGlobalsFetching,
	comboboxes,
	counts,
	search,
	patient,
	consultation,
	patients,
	isPatientsLoading
})

export default rootReducer


// WEBPACK FOOTER //
// ./src/reducers/index.js